import type { HttpGet, HttpRequest } from '@/shared/infra/http'
import type {
  ListRequiredWaivers,
  ListRequiredWaiversParams,
  ListRequiredWaiversResult,
  RequiredWaiverTemplate,
} from '@/modules/auth/use-cases'

type RawWaiverTemplate = {
  id?: string
  name?: string
  required?: boolean
}

type RawListRequiredWaiversResponse = {
  waivers?: RawWaiverTemplate[]
}

export class EdgeListRequiredWaiversRepository {
  constructor(private readonly httpClient: HttpGet) {}

  execute: ListRequiredWaivers = async (
    params: ListRequiredWaiversParams,
  ): Promise<ListRequiredWaiversResult> => {
    const search = new URLSearchParams({
      orgId: params.orgId,
      orgType: params.orgType,
      token: params.token,
    })
    const request: HttpRequest<never> = {
      url: `/waivers/required?${search.toString()}`,
    }
    const response =
      await this.httpClient.get<RawListRequiredWaiversResponse>(request)
    return mapResponse(response)
  }
}

function mapResponse(
  response: RawListRequiredWaiversResponse,
): ListRequiredWaiversResult {
  const raw = response ?? {}
  const waivers: RequiredWaiverTemplate[] = (raw.waivers ?? []).map(
    (entry) => ({
      templateId: entry.id ?? '',
      name: entry.name ?? '',
      required: entry.required ?? false,
    }),
  )
  return { waivers }
}
